import { render } from "./InternationalTrade.vue?vue&type=template&id=52e42732&scoped=true"
import script from "./InternationalTrade.vue?vue&type=script&lang=js"
export * from "./InternationalTrade.vue?vue&type=script&lang=js"

import "./InternationalTrade.vue?vue&type=style&index=0&id=52e42732&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e42732"]])

export default __exports__